import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData } from '@/auth/utils'
import pages from './routes/pages'
import user from './routes/menu/user'
import blog from './routes/menu/blog'
import tour from './routes/menu/tour'
import order from './routes/menu/order'
import banner from './routes/menu/banner'
import zaercard from './routes/menu/zaercard'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', name: 'home', redirect: { name: 'user' } },
    ...pages,
    ...user,
    ...blog,
    ...tour,
    ...order,
    ...banner,
    ...zaercard,
    // {
    //   path: '*',
    //   redirect: 'error-404',
    // },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to)) {
    //   // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'login' })
    //
    // If logged in => not authorized
    return next({ name: 'not-authorized' })
  }

  if (!isLoggedIn && to.name !== 'login') return next({ name: 'login' })

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next('/')
  }
  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
